"use strict";

exports.__esModule = true;
exports.getMetricQuery = exports.BIN_STATE = exports.BIN_DEVICE = exports.BIN_ACTIVITY = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var BIN_STATE = exports.BIN_STATE = "states";
var BIN_DEVICE = exports.BIN_DEVICE = "device";
var BIN_ACTIVITY = exports.BIN_ACTIVITY = "activities";
var aggregateBins = {
  states: {
    binName: "by_state",
    fieldName: "dimensions.state",
    aggType: "terms",
    options: {}
  },
  device: {
    binName: "by_device",
    fieldName: "entity.device",
    aggType: "terms",
    options: {}
  },
  activities: {
    binName: "by_activity",
    fieldName: "dimensions.activity",
    aggType: "terms",
    options: {
      missing: " "
    }
  }
};
var getMetricQuery = exports.getMetricQuery = function getMetricQuery(_ref) {
  var plant = _ref.plant,
    device = _ref.device,
    interval = _ref.interval,
    windowType = _ref.windowType,
    timezoneName = _ref.timezoneName,
    metrics = _ref.metrics,
    _ref$bins = _ref.bins,
    _bins = _ref$bins === void 0 ? [] : _ref$bins;
  var bins = _bins.map(function (binBy) {
    return aggregateBins[binBy];
  });
  if (windowType) {
    bins.push((0, _timeAggregationBinMapping.getTimeAggregationBin)(windowType, {
      timezoneName: timezoneName
    }));
  }
  return {
    filters: {
      must: [{
        filterType: "terms",
        fieldName: "entity.device",
        values: device
      }, {
        filterType: "term",
        fieldName: "entity.plant",
        values: plant
      }, {
        filterType: "range",
        fieldName: "timestamp",
        values: {
          gte: _moment["default"].utc(interval.startMillis).toISOString(),
          lt: _moment["default"].utc(interval.endMillis).toISOString()
        }
      }]
    },
    bins: bins,
    metrics: metrics
  };
};